import LogoColor from '@acorn-portal/shared/src/assets/streetcover/street-cover-header-logo-on-white.svg?react';
import Logo from '@acorn-portal/shared/src/assets/streetcover/street-cover-header-logo.svg?react';
import ChatButton from '@acorn-portal/shared/src/components/chat/ChatButton';
import Footer from '@acorn-portal/shared/src/components/footer';
import InactivityWarningModal from '@acorn-portal/shared/src/components/modal/InactivityWarningModal';
import Navbar from '@acorn-portal/shared/src/components/navbar';
import SecureRoute from '@acorn-portal/shared/src/components/routes/SecureRoute';
import ScrollToTop from '@acorn-portal/shared/src/components/ScrollToTop';
import { logErrorToSentry } from '@acorn-portal/shared/src/components/sentry/Integration';
import MakeAChangeJourneyWrapper from '@acorn-portal/shared/src/components/wrapper/MakeAChangeJourneyWrapper';
import { useInactivityTimer } from '@acorn-portal/shared/src/hooks/use-inactivity-timer';
import ContentWrapper from '@acorn-portal/shared/src/layouts/content-wrapper';
import VerifyAccount from '@acorn-portal/shared/src/pages/registration/VerifyAccount';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { Box, styled } from '@mui/material';
import * as Sentry from '@sentry/react';
import { useAuth } from 'react-oidc-context';
import { Outlet, useLocation, useNavigate } from 'react-router';
import GtmRouteListener from '../components/gtm-route-listener';
import { FooterDetails } from '../copy/StreetCoverCopy';

const Main = styled('main')({
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
});

const AuthorizedLayout = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const auth = useAuth();

	const handleSignout = () => {
		auth.removeUser();
		auth.signoutSilent({
			id_token_hint: auth.user?.id_token,
		});
	};

	const { isWarningActive, countdown, resetTimer } = useInactivityTimer({
		onInactivityExpired: handleSignout,
	});

	const handleStayLoggedIn = () => {
		auth.signinSilent();
		resetTimer();
	};

	const isVerified = auth?.user?.profile?.isVerified;

	return (
		<Main>
			<SecureRoute Logo={LogoColor}>
				<GtmRouteListener />
				<ScrollToTop />
				<Navbar Logo={Logo} logoHref='https://streetcover.co.uk/' />
				<Box sx={{ flexGrow: 1, width: '100%' }}>
					<ContentWrapper>
						<Box key={location.pathname}>
							<Sentry.ErrorBoundary
								onError={(e) => {
									logErrorToSentry(e);
									navigate(ROUTE_PATHS.error);
								}}
							>
								{isVerified ? (
									<MakeAChangeJourneyWrapper>
										<Outlet />
									</MakeAChangeJourneyWrapper>
								) : (
									<VerifyAccount />
								)}
							</Sentry.ErrorBoundary>
						</Box>
					</ContentWrapper>
				</Box>
				<Box
					style={{
						backgroundColor: '#f15b22',
						height: '6px',
					}}
				>
					&#8203; {/* // non width space to prevent box disappearing */}
				</Box>
				<Footer footerDetails={FooterDetails} />
				<ChatButton />
				<InactivityWarningModal open={isWarningActive} countdown={countdown} onStayLoggedIn={handleStayLoggedIn} />
			</SecureRoute>
		</Main>
	);
};

export default AuthorizedLayout;
